import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
    endpoints : (build) => ({
        getCuisine: build.query({
            query:(body) => ({
                url: "/cuisine/get",
                body
            })
        })
        
    })
}) 

export const { useGetCuisineQuery  } = extendedApi